<template>
    <modal-side-generic
    showFooter
    :title=selectedTransfer.descriptionDebit
    :subTitle="amountFormat(Math.abs(selectedTransfer.amount), selectedTransfer.currency)"
    :buttonsFooterData="buttonsFooterData"
    @hideMe="emit('hideMe')">
        <div v-for="(lineGroup, index) in recurringTransfersDetailArray" class="group-wrapper" :key="`lineGroup${lineGroup.index}`">
            <divider-generic :icon="lineGroup.icon" :title="lineGroup.label" :applyBorder="index !== 0"/>
            <!-- Text Block for each line -->
            <text-block-generic
            v-for="(line, index) in lineGroup.lines"
            :key="`lineGroupLine${line,index}`"
            :params="line"
            :mask="line.mask"
            applyEllipsis/>
        </div>
    </modal-side-generic>
</template>

<script setup>
import ModalSideGeneric from '@/components/generic/modals/side/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue & Helpers */
import { computed } from 'vue'
import { amountFormat } from '@/assets/scripts/amounts'
import { getDate } from '@/assets/scripts/dateBuilders'
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['cancelRecurringTransfer', 'redirectToEditFeature', 'hideMe'])

const props = defineProps({
    selectedTransfer: Array
})

/*************************************************
*                                                *
*        Recurring Transfers Detail Data         *
*                                                *
*************************************************/
const hasEndDateLabel = computed(() => {
    return props.selectedTransfer.hasUserDefinedEndDate ? t('transfers.periodic.recurringTransfersDetail.expiryDate') : t('transfers.periodic.recurringTransfersDetail.provenOtherwise')
})

const hasEndDateContent = computed(() => {
    return props.selectedTransfer.hasUserDefinedEndDate ? getDate(props.selectedTransfer.expiryDate) : ' '
})

const recurringTransfersDetailArray = computed(() => {
    return [
        {
            label: t('transfers.periodic.recurringTransfersDetail.originAccount'),
            icon: 'account-balance',
            lines: [{
                label: t('transfers.periodic.recurringTransfersDetail.account'),
                content: props.selectedTransfer.originAccount,
                mask: ACCOUNT_NUMBER
            }]
        },
        {
            label: t('transfers.periodic.recurringTransfersDetail.destinationAccount'),
            icon: 'account-balance',
            lines: [{
                label: t('transfers.periodic.recurringTransfersDetail.destinationAccountIBAN'),
                content: props.selectedTransfer.destinationAccount,
                mask: ACCOUNT_NUMBER

            }]
        },
        {
            label: t('transfers.periodic.recurringTransfersDetail.amount'),
            icon: 'bills',
            lines: [{
                label: t('transfers.periodic.recurringTransfersDetail.amount'),
                content: amountFormat(Math.abs(props.selectedTransfer.amount), props.selectedTransfer.currency)
            }]
        },
        {
            label: t('transfers.periodic.recurringTransfersDetail.frequency'),
            icon: 'clock',
            lines: [{
                label: t('transfers.periodic.recurringTransfersDetail.recurrence'),
                content: props.selectedTransfer.frequencyDescription
            },
            {
                label: t('transfers.periodic.recurringTransfersDetail.nextOccurrence'),
                content: getDate(props.selectedTransfer.nextOccurrence),
                classes: 'capitalize'
            },
            {
                label: hasEndDateLabel.value,
                content: hasEndDateContent.value,
                classes: 'capitalize'
            }]
        },
        {
            label: t('transfers.periodic.recurringTransfersDetail.organization'),
            icon: 'tag',
            content: props.selectedTransfer,
            lines: [{
                label: t('transfers.periodic.recurringTransfersDetail.descriptionCredit'),
                content: props.selectedTransfer.descriptionCredit

            }]
        }
    ]
})

const buttonsFooterData = [{
	label: t('transfers.periodic.recurringTransfersDetail.footerButtons.cancel'),
	secondVariant: true,
    buttonPosition: 'left',
    buttonType: 'negative',
	callbackFunction: () => { emit('cancelRecurringTransfer') }
}, {
	label: t('transfers.periodic.recurringTransfersDetail.footerButtons.edit'),
	secondVariant: false,
    buttonPosition: 'right',
    buttonType: 'primary',
    icon: 'pencil',
    iconPosition: 'right',
    callbackFunction: () => { emit('redirectToEditFeature', props.selectedTransfer) }
}]

</script>
